import React, { useState, useEffect, useRef } from "react";
import { useAPI } from "../Context/MyContext";
import {
  Phone,
  PhoneOff,
  Mic,
  MicOff,
  Volume2,
  VolumeX,
  MoreHorizontal,
  X,
  Signal,
} from "lucide-react";

const CallPopup = ({ callState, onEndCall }) => {
  const { socket, handlePreAccept, handleAcceptCall, handleTerminateCall, setCallState, cleanupCall, toggleMuteCall, setLocalStream } = useAPI();

  // console.log("📞 CallPopup rendered with state:", callState);

  const isIncoming = callState?.type === "incoming";
  const isOutgoing = callState?.type === "outgoing";

  const isRinging = callState?.status === "ringing";
  const isConnected = callState?.status === "connected";
  const isEnded = callState?.status === "ended";
  // const isCalling = isOutgoing && !isConnected && !isEnded;
  const isCalling = isOutgoing && callState?.status === "calling";


  const incomingCall = callState;
  const remoteSDP = callState?.remoteSDP;



  const [isMuted, setIsMuted] = useState(false);
  const [isSpeakerOff, setIsSpeakerOff] = useState(false);
  const [callTime, setCallTime] = useState(0);

  const peerConnection = useRef(null);
  const localAudioRef = useRef(null);
  const remoteAudioRef = useRef(null);
  const remoteStreamRef = useRef(new MediaStream());



  const [position, setPosition] = useState({ x: window.innerWidth / 2 - 180, y: 80 });
  const dragging = useRef(false);
  const dragOffset = useRef({ x: 0, y: 0 });




  // Call timer
  useEffect(() => {
    let timer;
    if (callState?.status === "connected") {
      timer = setInterval(() => setCallTime((prev) => prev + 1), 1000);
    } else {
      setCallTime(0);
    }
    return () => clearInterval(timer);
  }, [callState?.status]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  useEffect(() => {
    async function setupRemoteDescription() {
      if (!peerConnection.current) return;
      if (!callState?.remoteSDP) return;

      if (callState.type === "outgoing") {
        await peerConnection.current.setRemoteDescription({
          type: "answer",
          sdp: callState?.remoteSDP
        });

        // setCallState(prev => ({
        //   ...prev,
        //   status: "connected"
        // }));
      }
    }
    setupRemoteDescription();

  }, [callState?.remoteSDP]);


  useEffect(() => {
    async function setupRemoteDescription() {
      if (!peerConnection.current) {
        console.log("❌ No peerConnection for remote SDP");
        return;
      }

      if (!callState?.remoteSDP) {
        console.log("❌ No remote SDP received yet");
        return;
      }

      console.log("📩 Remote SDP received:", {
        type: callState.type,
        sdpLength: callState.remoteSDP?.length
      });

      if (callState.type === "outgoing") {
        console.log("📞 Setting remote ANSWER...");

        try {
          await peerConnection.current.setRemoteDescription({
            type: "answer",
            sdp: callState.remoteSDP
          });

          console.log("✅ Remote description set successfully");
          console.log("📡 Signaling state:", peerConnection.current.signalingState);

          // setCallState(prev => ({
          //   ...prev,
          //   status: "connected"
          // }));

        } catch (err) {
          console.error("❌ setRemoteDescription failed:", err);
        }
      }
    }

    setupRemoteDescription();
  }, [callState?.remoteSDP]);


  useEffect(() => {
    if (callState?.remoteStream && remoteAudioRef.current) {
      remoteAudioRef.current.srcObject = callState.remoteStream;

      remoteAudioRef.current.play().catch(err => {
        console.log("Audio play error:", err);
      });
    }
  }, [callState?.remoteStream]);

  // Accept call
  const handleAccept = async () => {
    if (!incomingCall || !remoteSDP) return;
    try {
      const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.l.google.com:19302" }] });
      peerConnection.current = pc;

      // pc.onconnectionstatechange = () => {
      //   console.log("🔗 Connection state:", pc.connectionState);
      // };

      // pc.oniceconnectionstatechange = () => {
      //   console.log("🧊 ICE connection state:", pc.iceConnectionState);
      // };

      pc.onconnectionstatechange = () => {
        console.log("🔗 Connection state:", pc.connectionState);

        if (pc.connectionState === "connected") {
          console.log("✅ CALL CONNECTED (via connectionState)");

          setCallState(prev => ({
            ...prev,
            status: "connected"
          }));
        }

        if (["disconnected", "failed", "closed"].includes(pc.connectionState)) {
          console.log("❌ CALL ENDED (via connectionState)");

          setCallState(prev => ({
            ...prev,
            status: "ended"
          }));
        }
      };

      pc.oniceconnectionstatechange = () => {
        console.log("🧊 ICE connection state:", pc.iceConnectionState);

        if (["connected", "completed"].includes(pc.iceConnectionState)) {
          console.log("✅ CALL CONNECTED (via ICE)");

          setCallState(prev => ({
            ...prev,
            status: "connected"
          }));
        }
      };

      pc.onsignalingstatechange = () => {
        console.log("📡 Signaling state:", pc.signalingState);
      };






      pc.ontrack = async (event) => {
        console.log("🎧 ontrack fired!");
        console.log("📦 Streams:", event.streams);
        console.log("🎵 Track:", event.track);
        console.log("🎵 Track enabled:", event.track.enabled);
        console.log("🎵 Track muted:", event.track.muted);
        console.log("🎵 Track readyState:", event.track.readyState);

        event.streams[0].getTracks().forEach(track => {
          remoteStreamRef.current.addTrack(track);
        });

        if (remoteAudioRef.current) {
          remoteAudioRef.current.srcObject = remoteStreamRef.current;

          console.log("🔊 Audio element state:", {
            muted: remoteAudioRef.current.muted,
            volume: remoteAudioRef.current.volume,
            paused: remoteAudioRef.current.paused
          });

          try {
            await remoteAudioRef.current.play();
            console.log("✅ Audio playing");
          } catch (err) {
            console.error("❌ Audio play failed:", err);
          }
        }
      };




      pc.onicecandidate = (event) => {
        if (event.candidate) {
          console.log("🧊 Sending ICE candidate:", event.candidate);
          const target = isIncoming ? callState.from : callState.to;

          socket.emit("call:ice-candidate", {
            candidate: event.candidate,
            to: target
          });
        } else {
          console.log("✅ ICE gathering complete");
        }
      };

      await pc.setRemoteDescription({ type: "offer", sdp: remoteSDP });
      const localStream = await navigator.mediaDevices.getUserMedia({ audio: true });

      setLocalStream(localStream); // ✅ now context knows
      console.log("🎤 Local stream tracks:", localStream.getTracks());

      // localStream.getTracks().forEach((track) => pc.addTrack(track, localStream));
      localStream.getTracks().forEach((track) => {
        console.log("🎤 Adding track:", track.kind, track.enabled);
        pc.addTrack(track, localStream);
      });

      if (localAudioRef.current) localAudioRef.current.srcObject = localStream;
      setIsMuted(false);
      const answer = await pc.createAnswer();
      await pc.setLocalDescription(answer);
      const backendPayload = {
        call_id: incomingCall.call_id,
        sdp: answer.sdp,
        phone_number_id: incomingCall.phone_number_id,
        caller: incomingCall.from,
      };
      await handlePreAccept(backendPayload);
      await handleAcceptCall(backendPayload);
      // setIncomingCall((prev) => ({ ...prev, accepted: true }));
      // setCallState(prev => ({ ...prev, status: "connected" }));
    } catch (err) {
      console.error("Call accept failed:", err);
    }
  };

  // Reject / End call
  // const handleReject = async () => {
  //   cleanupCall();
  //   if (!incomingCall) return;
  //   try {
  //     socket.emit("call:reject", { to: incomingCall.from });
  //     await handleTerminateCall({
  //       call_id: incomingCall.call_id,
  //       phone_number_id: incomingCall.phone_number_id,
  //       caller: incomingCall.from,
  //     });
  //   } catch (err) {
  //     console.error("Terminate failed:", err);
  //   }
  // };

  const handleReject = async () => {

    console.log("🚪 Ending call...");
    console.log("📞 Current call state:", callState);
    if (!callState) return;
    console.log("📞 Current call state: after Check", callState);

    const isIncoming = callState.type === "incoming";
    const target = isIncoming ? callState.from : callState.to;
    console.log("🎯 Target to notify:", target);

    try {
      // 🔹 Notify socket (optional but useful for peer sync)
      socket.emit("call:terminate", {
        to: target,
        call_id: callState.call_id
      });

      // 🔹 Tell backend (WhatsApp API)
      if (callState.call_id) {
        await handleTerminateCall({
          call_id: callState.call_id,
          phone_number_id: callState.phone_number_id,
          caller: target,
        });
      }

    } catch (err) {
      console.error("Terminate failed:", err);
    } finally {
      // 🔹 Always cleanup LAST
      onEndCall(); // or cleanupCall() if directly from context
    }
  };



  // ICE candidate
  useEffect(() => {
    if (!socket) return;


    const handler = async (data) => {
      console.log("📥 Received ICE candidate:", data);

      if (!peerConnection.current) {
        console.log("❌ No peerConnection for ICE");
        return;
      }

      try {
        await peerConnection.current.addIceCandidate(data.candidate);
        console.log("✅ ICE candidate added");
      } catch (err) {
        console.error("❌ ICE error:", err);
      }
    };

    socket.on("call:ice-candidate", handler);
    return () => socket.off("call:ice-candidate", handler);
  }, [socket]);

  // Drag
  const startDrag = (e) => { dragging.current = true; dragOffset.current = { x: e.clientX - position.x, y: e.clientY - position.y }; };
  const onDrag = (e) => { if (!dragging.current) return; setPosition({ x: e.clientX - dragOffset.current.x, y: e.clientY - dragOffset.current.y }); };
  const stopDrag = () => { dragging.current = false; };
  useEffect(() => {
    window.addEventListener("mousemove", onDrag);
    window.addEventListener("mouseup", stopDrag);
    return () => { window.removeEventListener("mousemove", onDrag); window.removeEventListener("mouseup", stopDrag); };
  }, []);



  const toggleMute = () => {
    console.log("🎙️ Toggling mute...");
    const enabled = toggleMuteCall();
    console.log("🎙️ Microphone enabled:", enabled);

    if (enabled !== undefined) {
      console.log("🎙️ Setting isMuted to:", !enabled);
      setIsMuted(!enabled); // UI state is inverse
    }
  };

  const toggleSpeaker = () => {
    if (!remoteAudioRef.current) return;
    const audio = remoteAudioRef.current;
    if (isSpeakerOff) {
      audio.volume = 1.0;
    } else {
      audio.volume = 0.3;
    }
    setIsSpeakerOff(!isSpeakerOff);
  };

  // if (!incomingCall) return null;
  if (!callState || callState.status === "idle") return null;

  return (
    <div
      style={{ position: "fixed", left: position.x, top: position.y, zIndex: 2147483647, width: 360 }}
      className="rounded-2xl overflow-hidden select-none shadow-2xl"
    >
      {/* ══════════════════════════════════════
          INCOMING CALL SCREEN
      ══════════════════════════════════════ */}
      {/* {!incomingCall.accepted ? ( */}
      {!isConnected ? (
        <div style={{ background: "linear-gradient(170deg, #1c2733 0%, #0d1418 100%)" }}>

          {/* Draggable top bar — just "Incoming Call" label + close */}
          <div onMouseDown={startDrag} className="cursor-move flex items-center justify-between px-4 pt-4 pb-2">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#00a884] animate-pulse" />
              {/* <span className="text-[#8696a0] text-xs font-medium uppercase tracking-widest">Incoming Call</span> */}

              <span>
                {/* {isIncoming
                  ? "Incoming Call"
                  : isCalling
                    ? "Calling..."
                    : isRinging
                      ? "Ringing..."
                      : "Active Call"} */}
                {isConnected
                  ? "Active Call"
                  : isIncoming
                    ? "Incoming Call"
                    : isRinging
                      ? "Ringing..."
                      : "Calling..."}

              </span>
            </div>
            <button
              onClick={handleReject}
              className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
            >
              <X size={15} className="text-white" />
            </button>
          </div>

          {/* Avatar */}
          <div className="flex flex-col items-center pt-5 pb-2 gap-3 px-6">
            <div className="w-24 h-24 rounded-full bg-[#2a3942] overflow-hidden ring-4 ring-white/10 flex items-center justify-center shadow-xl">
              <span className="text-5xl">👤</span>
            </div>
            <div className="text-center">
              {/* <p className="text-white text-xl font-semibold">{incomingCall.from}</p>
              <p className="text-gray-400 text-sm mt-0.5">{incomingCall.from}</p> */}
              <p className="text-white text-xl font-semibold">

                {callState.to}
              </p>
              <p className="text-[#8696a0] text-sm mt-1.5">Voice call</p>
            </div>
          </div>

          <audio ref={localAudioRef} autoPlay muted />
          <audio ref={remoteAudioRef} autoPlay playsInline />

          {/* Bottom action row */}
          <div className="flex items-center gap-3 px-5 pb-7 pt-4">
            {/* More */}
            {/* <button className="w-12 h-12 rounded-full bg-[#202c33] flex items-center justify-center hover:bg-[#2a3942] transition-colors shadow-md">
              <MoreHorizontal size={19} className="text-white" />
            </button> */}

            {/* Accept */}

            {isIncoming && (
              <button
                onClick={handleAccept}
                className="flex-1 h-14 rounded-full bg-[#00a884] flex items-center justify-center gap-2 text-white font-semibold text-[15px] hover:bg-[#008f6f] transition-colors shadow-lg"
                style={{ boxShadow: "0 4px 20px rgba(0,168,132,0.35)" }}
              >
                <Phone size={20} />
                Accept
              </button>
            )
            }



            {/* Decline */}
            <button
              onClick={handleReject}
              className="flex-1 mx-4 h-14 rounded-full bg-[#ef4444] flex items-center justify-center gap-2 text-white font-semibold text-[15px] hover:bg-[#dc2626] transition-colors"
              style={{ boxShadow: "0 4px 20px rgba(239,68,68,0.4)" }}
            >
              <PhoneOff size={20} className="text-white" />
              <span>End Call</span>
            </button>
          </div>
        </div>
      ) : (
        /* ══════════════════════════════════════
            ACTIVE CALL SCREEN
        ══════════════════════════════════════ */
        <div style={{ background: "linear-gradient(180deg, #111b21 0%, #0d1418 100%)" }}>

          {/* Draggable top bar */}
          <div onMouseDown={startDrag} className="cursor-move flex items-center justify-between px-4 py-3 border-b border-white/5">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#00a884] animate-pulse" />
              <span className="text-[#8696a0] text-xs font-medium uppercase tracking-widest">Active Call</span>
            </div>
            {/* <div className="flex items-center gap-1.5 text-[#8696a0] text-xs">
              <Signal size={13} className="text-[#00a884]" />
              <span className="text-[#00a884] font-medium">Good signal</span>
            </div> */}
          </div>

          {/* Avatar + name + animated dots + timer */}
          <div className="flex flex-col items-center pt-10 pb-8 px-6 gap-3">
            <div className="w-28 h-28 rounded-full bg-[#2a3942] overflow-hidden ring-4 ring-white/10 flex items-center justify-center shadow-2xl">
              <span className="text-6xl">👤</span>
            </div>

            <p className="text-white text-2xl font-semibold tracking-tight mt-1">{incomingCall.to}</p>

            {/* Animated green dots */}
            <div className="flex items-center gap-[3px]">
              {Array.from({ length: 13 }).map((_, i) => (
                <div
                  key={i}
                  className="w-1.5 h-1.5 rounded-full bg-[#00a884]"
                  style={{ opacity: 0.4 + (i % 3) * 0.2, animation: `pulse 1.4s ease-in-out ${i * 0.1}s infinite` }}
                />
              ))}
            </div>

            <p className="text-white text-lg font-light tracking-[0.15em]">{formatTime(callTime)}</p>
          </div>

          <audio ref={localAudioRef} autoPlay muted />
          <audio ref={remoteAudioRef} autoPlay playsInline />

          {/* Bottom controls bar */}
          <div className="bg-[#182229] flex items-center justify-between px-6 py-3.5">

            {/* Speaker */}
            <button
              onClick={toggleSpeaker}
              className="w-12 h-12 rounded-full bg-[#2a3942] flex items-center justify-center hover:bg-[#374f5c] transition-colors shadow"
            >
              {isSpeakerOff
                ? <VolumeX size={20} className="text-white" />
                : <Volume2 size={20} className="text-white" />
              }
            </button>

            {/* End call — wide centered pill like Accept */}
            <button
              onClick={handleReject}
              className="flex-1 mx-4 h-14 rounded-full bg-[#ef4444] flex items-center justify-center gap-2 text-white font-semibold text-[15px] hover:bg-[#dc2626] transition-colors"
              style={{ boxShadow: "0 4px 20px rgba(239,68,68,0.4)" }}
            >
              <PhoneOff size={20} className="text-white" />
              <span>End Call</span>
            </button>

            {/* Mic */}
            <button
              onClick={toggleMute}
              className="w-12 h-12 rounded-full bg-[#2a3942] flex items-center justify-center hover:bg-[#374f5c] transition-colors shadow"
            >
              {isMuted
                ? <MicOff size={20} className="text-white" />
                : <Mic size={20} className="text-white" />
              }
            </button>

          </div>
        </div>
      )}
    </div>
  );
};

export default CallPopup;